// #region Action type for email configuration
export const Get_Whatsapp_Config_Data = "Get_Whatsapp_Config_Data";
export const Post_Whatsapp_Config_Data = "Post_Whatsapp_Config_Data";
export const Get_SingleWhatsapp_Config_Data = "Get_SingleWhatsapp_Config_Data";
// #endregion

// #region Action type for email configuration
export const Get_Email_Config_Data = "Get_Email_Config_Data"
export const Post_Email_Config_Data = "Post_Email_Config_Data"
// #endregion